import client from './client';
import type { Transfer } from '@/types/api';

export interface CreateTransferRequest {
  productVariantId: string;
  fromLocationId: string;
  toLocationId: string;
  quantity: number;
  transferDate?: string;
  notes?: string;
}

export const transfersApi = {
  getAll: async (): Promise<Transfer[]> => {
    const response = await client.get<Transfer[]>('/transfers');
    return response.data;
  },

  getByLocation: async (locationId: string): Promise<Transfer[]> => {
    const response = await client.get<Transfer[]>(`/transfers/location/${locationId}`);
    return response.data;
  },

  getByProduct: async (productId: string): Promise<Transfer[]> => {
    const response = await client.get<Transfer[]>(`/transfers/product/${productId}`);
    return response.data;
  },

  getByDateRange: async (startDate: string, endDate: string): Promise<Transfer[]> => {
    const response = await client.get<Transfer[]>('/transfers', {
      params: { startDate, endDate }
    });
    return response.data;
  },

  create: async (data: CreateTransferRequest): Promise<Transfer> => {
    const response = await client.post<Transfer>('/transfers', data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/transfers/${id}`);
  },
};
